import { lensPath, view } from 'ramda';

const roleNameLens = lensPath(['role', 'name']);

const nameLens = lensPath(['name']);

export const getRoleName = view(roleNameLens);

export const getName = view(nameLens);
